var SubtitleTabsData = require('../modules/SubtitleTabsData/SubtitleTabsData');
var DataProcessor = require('../modules/DataProcessor/DataProcessor');
var dataProcessorActivator = require('../modules/DataProcessorActivator/DataProcessorActivator');
require('../portlets/price_comparator');
require('../modules/ActiveUserInfo/ActiveUserInfo');
require('../modules/AsyncBtn/AsyncBtn');
require('../modules/DataEntryAgregat/DataEntryAgregat');
var CalculatedStatDisplay = require('../modules/CalculatedStatDisplay/CalculatedStatDisplay');




//////////////////
// WEBPACK FOOTER
// ./src/js/imports.js
// module id = 0
// module chunks = 0